import PropTypes from 'prop-types'
import { numberToCurrency } from 'lib/money'
import { format } from 'date-fns'

const OrderPanelInfo = ({ className, reference, createdAt, total }) => {
  return (
    <div className={className}>
      <div className="h6 mbs text-uppercase text-bold">
        {format(new Date(createdAt), 'MMMM d, yyyy')}
      </div>
      <div className="h6 mvs">{`Order Number: ${reference}`}</div>
      <div className="h6 mvs">{`Order Total: ${numberToCurrency(total)}`}</div>
    </div>
  )
}

OrderPanelInfo.defaultProps = {
  className: PropTypes.string,
}

OrderPanelInfo.propTypes = {
  className: PropTypes.string,
  createdAt: PropTypes.string.isRequired,
  reference: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
}

export default OrderPanelInfo
